<template>
  <VanPopup
    :show="show"
    class="colorful-bg border-2 border-white w-[300px]"
    closeable
    position="center"
    round
    @update:show="emit('update:show', $event)"
  >
    <div
      class="flex flex-col justify-center items-center gap-4 py-12 px-4 text-center"
    >
      <span
        class="colorful-bg w-[200px] aspect-[3/4] rounded-bl-full rounded-br-full border-2 border-white/80 overflow-hidden relative drop-shadow-2xl"
      >
        <img
          alt=""
          class="w-full"
          src="/img/pay/pay-banner.png"
          crossorigin="anonymous"
        />
      </span>
      <div class="flex items-center gap-1 font-bold">
        <span>{{ $t(`purchase.miss.name`) }}</span>
        <PowerIcon class="icon-lg" />
        <span class="text-base">{{ missAmount }}</span>
      </div>
      <span
        class="flex items-center gap-1"
        v-html="
          $t(`purchase.miss.power`, {
            crystal: shouldBuyCount,
            power: shouldBuyCount * 20,
          })
        "
      />

      <div class="grid grid-cols-2 gap-4">
        <button class="btn glass" @click="clickBuyMore">
          {{ t(`purchase.miss.other`) }}
        </button>
        <button class="btn btn-warning" @click="clickPayCrystal">
          <CrystalIcon class="icon-xl" />
          <span>{{ shouldBuyCount }}</span>
        </button>
      </div>
    </div>
  </VanPopup>
</template>
<script lang="ts" setup>
import { ApiPostCrystalTransactionBuyPower } from "@/apis/crystal";
import { useGlobalUser } from "@/stores/globalUser";
import { showFailToast, showLoadingToast, showSuccessToast } from "vant";
import { computed, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

const userStore = useGlobalUser();

const router = useRouter();
const props = defineProps({
  show: {
    type: Boolean,
    required: true,
  },
  missAmount: {
    type: Number,
    default: 0,
  },
});

const shouldBuyCount = computed(() => Math.ceil(props.missAmount / 20));

const emit = defineEmits<{
  (e: "update:show", val: boolean): void;
  (e: "paid"): void;
}>();
const { t } = useI18n();

const clickBuyMore = () => {
  router.push(`/crystal#2`);
};

const clickPayCrystal = async () => {
  if (userStore.user.crystalQuantity < shouldBuyCount.value) {
    showFailToast(t("Message.notEnoughCrystal"));
    await router.push(`/crystal#1`);
  } else {
    const loading = showLoadingToast(t("Message.swapping"));
    try {
      await ApiPostCrystalTransactionBuyPower(shouldBuyCount.value);
      userStore.updateCurrentMateId();
      loading.close();
      showSuccessToast(t("Message.exchangeSuccess"));
      emit("paid");
      emit("update:show", false);
    } catch (e) {
      // ignore
    }
    loading.close();
  }
};

onMounted(() => {});
</script>
<style scoped>
.colorful-bg {
  background-image: var(--colorful-gradient-t);
}

:deep(.van-popup__close-icon--top-right) {
  color: white;
}
</style>
